export default {
  'pages.request.loginExpired': 'Login expired, please sign in again',
  'pages.request.accessDenied':
    'You do not have permission to perform this action',
  'pages.request.responseStatus': 'Request failed (HTTP {status})',
  'pages.request.noResponse': 'The server did not respond. Please try again.',
  'pages.request.error': 'The request failed. Please try again.',
  'pages.login.success': 'Login successful!',
  'pages.login.permissionsLoadFailed':
    'Permissions could not be loaded. Opened the personal address book; refresh to retry.',
  'pages.login.permissionsRetry': 'Retry',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please enter your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please enter your password!',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password?',
  'pages.login.forgotPasswordInfo':
    'Please contact administrator to reset password',
  'pages.login.submit': 'Login',
  'pages.login.back': 'Back',
  'pages.login.emailCheck.title': 'Email Verification',
  'pages.login.emailCheck.description':
    'A 6-digit code has been sent to {email}',
  'pages.login.emailCheck.sent':
    'A verification code has been sent to your email',
  'pages.login.tfaCheck.title': 'Two-Factor Authentication',
  'pages.login.tfaCheck.description':
    'Enter the 6-digit code from your authenticator app',
  'pages.login.verifyCode.submit': 'Verify',
  'pages.login.verifyCode.invalid': 'Invalid verification code',
  'pages.login.oidc.divider': 'Or continue with',
  'pages.login.oidc.continueWith': 'Continue with {provider}',
  'pages.login.oidc.authFailed': 'OIDC login failed',
  'pages.login.passkey.login': 'Sign in with Passkey',
  'pages.login.passkey.verify': 'Verify with Passkey',
  'pages.login.passkey.cancelled': 'Passkey verification was cancelled',
  'pages.login.passkey.failed': 'Passkey verification failed',
  'pages.login.passkeyCheck.title': 'Passkey Verification',
  'pages.login.passkeyCheck.description':
    'Use your Passkey to complete sign-in',
  'pages.devices.list': 'Device List',
  'pages.devices.os': 'OS',
  'pages.devices.status': 'Status',
  'pages.devices.user': 'User',
  'pages.devices.deviceGroup': 'Group',
  'pages.devices.note': 'Note',
  'pages.devices.online': 'Online',
  'pages.devices.offline': 'Offline',
  'pages.devices.days': 'days',
  'pages.devices.hours': 'hours',
  'pages.devices.minutes': 'minutes',
  'pages.devices.justNow': 'just now',
  'pages.devices.enable': 'Enable',
  'pages.devices.disable': 'Disable',
  'pages.devices.enableSuccess': 'Device enabled',
  'pages.devices.enableFailed': 'Failed to enable device',
  'pages.devices.disableSuccess': 'Device disabled',
  'pages.devices.disableFailed': 'Failed to disable device',
  'pages.devices.deleteSuccess': 'Device deleted',
  'pages.devices.deleteFailed': 'Failed to delete device',
  'pages.devices.deleteConfirm': 'Are you sure to delete this device?',
  'pages.devices.deviceInfo': 'username@device_name',
  'pages.devices.strategyInfo': 'Strategy Info',
  'pages.devices.device': 'Device',
  'pages.devices.strategy': 'Strategy',
  'pages.devices.info': 'Info',
  'pages.devices.statusNormal': 'Normal',
  'pages.devices.statusDisabled': 'Disabled',
  'pages.devices.onlineStatus': 'Online Status',
  'pages.devices.deviceGroupSearchTip': 'Filter by device group name',
  'pages.devices.remove': 'Remove',
  'pages.devices.removeFromGroupSuccess': 'Device removed from group',
  'pages.devices.removeFromGroupFailed': 'Failed to remove device from group',
  'pages.devices.removeFromGroupConfirm':
    'Are you sure to remove this device from the group?',
  'pages.devices.batchRemove': 'Batch Remove',
  'pages.devices.batchRemoveFromGroupSuccess':
    'Successfully removed {count} device(s) from group',
  'pages.devices.batchRemoveFromGroupFailed':
    'Failed to remove devices from group',
  'pages.devices.batchRemoveFromGroupConfirm':
    'Are you sure to remove selected devices from the group?',
  'pages.devices.batchEnable': 'Batch Enable',
  'pages.devices.batchDisable': 'Batch Disable',
  'pages.devices.batchEnableConfirm':
    'Are you sure to enable selected devices?',
  'pages.devices.batchDisableConfirm':
    'Are you sure to disable selected devices?',
  'pages.devices.batchEnableSuccess': 'Successfully enabled {count} device(s)',
  'pages.devices.batchEnableFailed': 'Failed to enable devices',
  'pages.devices.batchEnablePartialFailed':
    'Successfully enabled {success} device(s), {failed} failed',
  'pages.devices.batchDisableSuccess':
    'Successfully disabled {count} device(s)',
  'pages.devices.batchDisableFailed': 'Failed to disable devices',
  'pages.devices.batchDisablePartialFailed':
    'Successfully disabled {success} device(s), {failed} failed',
  'pages.devices.edit': 'Edit Device',
  'pages.devices.updateSuccess': 'Device updated',
  'pages.devices.updateFailed': 'Failed to update device',
  'pages.devices.selectUser': 'Select user',
  'pages.devices.selectDeviceGroup': 'Select device group',
  'pages.devices.selectStrategy': 'Select strategy',
  'pages.devices.connect': 'Connect',
  'pages.devices.connectRemoteDesktop': 'Remote Desktop',
  'pages.devices.connectFileTransfer': 'File Transfer',
  'pages.devices.connectViewCamera': 'View Camera',
  'pages.devices.connectPortForward': 'Port Forward',
  'pages.devices.connectRdp': 'RDP',
  'pages.devices.connectTerminal': 'Terminal',
  'pages.devices.connectTerminalAdmin': 'Terminal (Admin)',
  'pages.devices.searchIdPlaceholder': 'Search by device ID',
  'pages.devices.searchUserPlaceholder': 'Search by username',
  'pages.devices.searchOsPlaceholder': 'Search by OS',
  'pages.devices.searchDeviceGroupPlaceholder': 'Search by device group name',
  'pages.addressBook.name': 'Name',
  'pages.addressBook.note': 'Note',
  'pages.addressBook.shared': 'Shared Address Books',
  'pages.addressBook.create': 'Create Address Book',
  'pages.addressBook.edit': 'Edit Address Book',
  'pages.addressBook.personal': 'Personal Address Book',
  'pages.addressBook.currentAddressBook': 'Address book',
  'pages.addressBook.myAddressBook': 'My address book',
  'pages.addressBook.loadFailed': 'Failed to load address books',
  'pages.addressBook.addPeer': 'Add by ID',
  'pages.addressBook.addTag': 'Add Tag',
  'pages.addressBook.tagName': 'Tag Name',
  'pages.addressBook.tagAdded': 'Tag added',
  'pages.addressBook.tagAddFailed': 'Failed to add tag',
  'pages.addressBook.tagDeleted': 'Tag deleted',
  'pages.addressBook.tagDeleteFailed': 'Failed to delete tag',
  'pages.addressBook.deleteTagConfirm': 'Are you sure to delete this tag?',
  'pages.addressBook.tagModeUnion': 'Any',
  'pages.addressBook.tagModeIntersection': 'All',
  'pages.addressBook.importDevices': 'Import from Devices',
  'pages.addressBook.importSuccess': 'Successfully imported {count} device(s)',
  'pages.addressBook.importPartialFailed': '{count} device(s) failed to import',
  'pages.addressBook.createSuccess': 'Address book created',
  'pages.addressBook.createFailed': 'Failed to create address book',
  'pages.addressBook.updateSuccess': 'Address book updated',
  'pages.addressBook.updateFailed': 'Failed to update address book',
  'pages.addressBook.deleteSuccess': 'Address book(s) deleted',
  'pages.addressBook.deleteFailed': 'Failed to delete address book(s)',
  'pages.addressBook.deleteConfirm':
    'Are you sure to delete this address book?',
  'pages.addressBook.batchDeleteConfirm':
    'Are you sure to delete selected address books?',
  'pages.addressBook.device': 'Device',
  'pages.addressBook.alias': 'Alias',
  'pages.addressBook.tags': 'Tags',
  'pages.addressBook.peerAdded': 'Peer added',
  'pages.addressBook.peerAddFailed': 'Failed to add peer',
  'pages.addressBook.peerDeleted': 'Peer deleted',
  'pages.addressBook.peerDeleteFailed': 'Failed to delete peer',
  'pages.addressBook.deletePeerConfirm': 'Are you sure to delete this peer?',
  'pages.addressBook.import': 'Import from Devices',
  'pages.deviceGroups.list': 'Device Groups',
  'pages.deviceGroups.name': 'Name',
  'pages.deviceGroups.note': 'Note',
  'pages.deviceGroups.create': 'Create Device Group',
  'pages.deviceGroups.edit': 'Edit Device Group',
  'pages.deviceGroups.createSuccess': 'Device group created',
  'pages.deviceGroups.createFailed': 'Failed to create device group',
  'pages.deviceGroups.updateSuccess': 'Device group updated',
  'pages.deviceGroups.updateFailed': 'Failed to update device group',
  'pages.deviceGroups.deleteSuccess': 'Device group deleted',
  'pages.deviceGroups.deleteFailed': 'Failed to delete device group',
  'pages.deviceGroups.deleteConfirm':
    'Are you sure to delete this device group?',
  'pages.deviceGroups.import': 'Import',
  'pages.deviceGroups.importDevices': 'Import Devices',
  'pages.deviceGroups.importSuccess': 'Successfully imported {count} device(s)',
  'pages.deviceGroups.importFailed': 'Failed to import devices',
  'pages.deviceGroups.searchNamePlaceholder': 'Search by name',
  'pages.users.list': 'User List',
  'pages.users.name': 'Name',
  'pages.users.displayName': 'Display Name',
  'pages.users.email': 'Email',
  'pages.users.note': 'Note',
  'pages.users.status': 'Status',
  'pages.users.create': 'Create User',
  'pages.users.createSuccess': 'User created',
  'pages.users.createFailed': 'Failed to create user',
  'pages.users.deleteSuccess': 'User deleted',
  'pages.users.deleteFailed': 'Failed to delete user',
  'pages.users.deleteConfirm': 'Are you sure to delete this user?',
  'pages.audits.conn': 'Connection Audits',
  'pages.audits.file': 'File Transfer Logs',
  'pages.audits.alarm': 'Alarm Audits',
  'pages.audits.console': 'Console Audits',
  'pages.audits.requestedAt': 'Requested At',
  'pages.audits.establishedAt': 'Established At',
  'pages.audits.closedAt': 'Closed At',
  'pages.audits.action': 'Action',
  'pages.audits.time': 'Time',
  'pages.audits.alarmType': 'Alarm Type',
  'pages.audits.user': 'User',
  'pages.audits.detail': 'Detail',
  'pages.audits.operator': 'Operator',
  'pages.audits.targetType': 'Target type',
  'pages.audits.targetId': 'Target ID',
  'pages.audits.result': 'Result',
  'pages.audits.reason': 'Reason',
  'pages.audits.unknownUser': 'Unknown user',
  'pages.audits.result.allowed': 'Allowed',
  'pages.audits.result.denied': 'Denied',
  'pages.audits.target': 'Target',
  'pages.audits.beforeState': 'Before state',
  'pages.audits.afterState': 'After state',
  'pages.audits.type': 'Type',
  'pages.audits.connType.remoteDesktop': 'Remote Desktop',
  'pages.audits.connType.fileTransfer': 'File Transfer',
  'pages.audits.connType.portTransfer': 'Port Transfer',
  'pages.audits.connType.viewCamera': 'View Camera',
  'pages.audits.connType.terminal': 'Terminal',
  'pages.audits.connType.notLoggedIn': 'Not Logged In',
  'pages.audits.duration': 'Duration',
  'pages.audits.note': 'Note',
  'pages.audits.disconnect': 'Disconnect',
  'pages.audits.connectionId': 'Connection ID',
  'pages.audits.currentConnections': 'Current Connections',
  'pages.audits.disconnectSuccess': 'Disconnect request submitted',
  'pages.audits.disconnectFailed': 'Disconnect failed!',
  'pages.audits.disconnectConfirmTitle': 'Confirm Operation',
  'pages.audits.disconnectConfirmTip':
    'Are you sure you want to disconnect this device?',
  'pages.audits.updateSuccess': 'Update is successful',
  'pages.audits.updateFailed': 'Update failed, please try again!',
  'pages.audits.exportCSV': 'Export CSV',
  'pages.audits.noDataToExport': 'No data to export',
  'pages.audits.exportSuccess': 'Export successful',
  'pages.audits.exportFailed': 'Export failed',
  'pages.audits.exportConfirmTitle': 'Export CSV',
  'pages.audits.exportConfirmContent': 'Export up to 1000 records. Continue?',
  'pages.audits.remote': 'Remote',
  'pages.audits.local': 'Local',
  'pages.audits.direction': 'Direction',
  'pages.audits.files': 'Files',
  'pages.audits.remoteTip': 'Remotely controlled computer or terminal',
  'pages.audits.remoteSearchTip': 'Search by remote device ID (fuzzy match)',
  'pages.audits.remotePlaceholder': 'Enter remote device ID',
  'pages.audits.pathTip': 'Path of Remote Device',
  'pages.audits.exportCsvTip': 'Export up to 1000 records at a time',
  'pages.audits.limitedTip': 'Show the 10 largest files by size',
  'pages.audits.startTime': 'Start Time',
  'pages.audits.endTime': 'End Time',
  'pages.audits.alarmType.ipWhitelist': 'IP Not in Whitelist',
  'pages.audits.alarmType.exceedThirtyAttempts':
    'Same IP Exceeds 30 Failed Attempts',
  'pages.audits.alarmType.sixAttemptsWithinOneMinute':
    'More Than 6 Attempts Within 1 Minute',
  'pages.audits.alarmType.exceedIpv6PrefixAttempts':
    'IPv6 Prefix Attempt Limit Exceeded',
  'pages.audits.alarmType.terminalOsLoginBackoff':
    'Terminal OS Login Blocked by Backoff',
  'pages.audits.alarmType.terminalOsLoginConcurrency':
    'Terminal OS Login Concurrency Limit Exceeded',
  'pages.audits.alarmType.sessionScopeViolation':
    'Session Scope Permission Violation',
  'pages.audits.alarmType.idWhitelist': 'ID Not in Whitelist',
  'pages.audits.primaryAuth': 'Primary Auth',
  'pages.audits.primaryAuth.none': 'None',
  'pages.audits.primaryAuth.click': 'Click',
  'pages.audits.primaryAuth.temporaryPassword': 'Temporary Password',
  'pages.audits.primaryAuth.permanentPassword': 'Permanent Password',
  'pages.audits.primaryAuth.switchSides': 'Switch Sides',
  'pages.audits.twoFactor': 'Two-Factor Auth',
  'pages.audits.twoFactor.none': 'None',
  'pages.audits.twoFactor.totp': 'TOTP',
  'pages.audits.twoFactor.trustedDevice': 'Trusted Device',
  'pages.audits.searchOperatorPlaceholder': 'Search by operator',
  'pages.audits.searchActionPlaceholder': 'Search by action',
  'pages.audits.searchTargetTypePlaceholder': 'Search by target type',
  'pages.common.action': 'Action',
  'pages.common.delete': 'Delete',
  'pages.common.edit': 'Edit',
  'pages.common.batchDelete': 'Batch Delete',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist',
  'pages.404.buttonText': 'Back to Home',
  'pages.customClients.createdAt': 'Created At',
  'pages.userGroups.list': 'User Group List',
  'pages.userGroups.name': 'Group Name',
  'pages.userGroups.note': 'Note',
  'pages.userGroups.userCount': 'User Count',
  'pages.userGroups.create': 'Create User Group',
  'pages.userGroups.edit': 'Edit User Group',
  'pages.userGroups.deleteConfirm': 'Are you sure to delete this user group?',
  'pages.userGroups.createSuccess': 'User group created',
  'pages.userGroups.createFailed': 'Failed to create user group',
  'pages.userGroups.updateSuccess': 'User group updated',
  'pages.userGroups.updateFailed': 'Failed to update user group',
  'pages.userGroups.deleteSuccess': 'User group deleted',
  'pages.userGroups.deleteFailed': 'Failed to delete user group',
  'pages.userGroups.loadFailed': 'Failed to load user groups',
  'pages.userGroups.default': 'Default',
  'pages.userGroups.destination': 'Destination group',
  'pages.userGroups.selectDestination': 'Select destination group',
  'pages.userGroups.move': 'Move',
  'pages.userGroups.batchMove': 'Batch Move',
  'pages.userGroups.moveToGroup': 'Move to group',
  'pages.userGroups.import': 'Import',
  'pages.userGroups.importUsers': 'Import Users',
  'pages.userGroups.importSuccess': 'Successfully imported {count} user(s)',
  'pages.userGroups.importFailed': 'Failed to import users',
  'pages.userGroups.membersUpdated': 'Updated {count} user(s)',
  'pages.userGroups.membersUpdateFailed': 'Failed to update group members',
  'pages.userGroups.members': 'Members',
  'pages.userGroups.moveSelected': 'Move selected',
  'pages.userGroups.addSelected': 'Add selected users',
  'pages.userGroups.membersTitle': '{name} members',
  'pages.userGroups.currentMembers': 'Current members',
  'pages.userGroups.addUsers': 'Add users',
  'pages.users.userGroup': 'User Group',
  'pages.users.selectUserGroup': 'Select user group',
  'pages.addressBook.userGroup': 'User group',
  'pages.addressBook.permission': 'Permission',
  'pages.addressBook.permissionRead': 'Read only',
  'pages.addressBook.permissionReadWrite': 'Read and write',
  'pages.addressBook.permissionFull': 'Full control',
  'pages.addressBook.shareAccess': 'Share',
  'pages.addressBook.accessTitle': '{name} - Access management',
  'pages.addressBook.accessReadOnlyTitle': '{name} - Sharing settings',
  'pages.addressBook.viewShareSettings': 'Sharing settings',
  'pages.addressBook.shareType': 'Share type',
  'pages.addressBook.shareTarget': 'Target',
  'pages.addressBook.shareTypeEveryone': 'Everyone',
  'pages.addressBook.shareTypeUser': 'User',
  'pages.addressBook.shareTypeGroup': 'User group',
  'pages.addressBook.selectUser': 'Select user',
  'pages.addressBook.selectUserPlaceholder': 'Search by username or email',
  'pages.addressBook.everyoneHint':
    'All users will have access to this address book',
  'pages.addressBook.allUsers': 'All users',
  'pages.addressBook.addAccess': 'Add access',
  'pages.addressBook.accessLoadFailed': 'Failed to load access rules',
  'pages.addressBook.accessAdded': 'Access rule added',
  'pages.addressBook.accessAddFailed': 'Failed to add access rule',
  'pages.addressBook.accessUpdated': 'Access rule updated',
  'pages.addressBook.accessUpdateFailed': 'Failed to update access rule',
  'pages.addressBook.accessDeleted': 'Access rule deleted',
  'pages.addressBook.accessDeleteFailed': 'Failed to delete access rule',
  'pages.addressBook.accessDeleteConfirm': 'Delete this access rule?',
  'pages.roles.list': 'Role List',
  'pages.roles.name': 'Role Name',
  'pages.roles.note': 'Note',
  'pages.roles.permissions': 'Permissions',
  'pages.roles.permissionsInfo':
    'Number of effective permissions and capabilities',
  'pages.roles.superAdminInfo':
    'Super-administrator access is protected separately and cannot be granted through a role.',
  'pages.roles.permissionsLoadFailed': 'Failed to load the permission catalog',
  'pages.roles.detailLoadFailed': 'Failed to load role details',
  'pages.roles.permissionScopeInfo':
    'Device actions can be assigned globally or to selected device groups when a user receives this role.',
  'pages.roles.personalAddressBook': 'Personal address book',
  'pages.roles.basicFunction': 'Basic feature',
  'pages.roles.permissionPresets': 'Permission presets',
  'pages.roles.preset.custom': 'Custom',
  'pages.roles.preset.readOnly': 'Global read-only',
  'pages.roles.preset.deviceOperator': 'Device operator',
  'pages.roles.preset.userAdministrator': 'User administrator',
  'pages.roles.preset.sharedAddressBookAdministrator':
    'Shared address book administrator',
  'pages.roles.preset.strategyMaintainer': 'Strategy maintainer',
  'pages.roles.preset.deviceStrategyAssigner': 'Device strategy assigner',
  'pages.roles.preset.systemAdministrator': 'System administrator',
  'pages.roles.protectedAccount': 'Protected accounts',
  'pages.roles.protectedAccountInfo':
    'Only the super administrator can manage protected accounts.',
  'pages.roles.ownerOnly': 'Super administrator only',
  'pages.roles.systemIdentity.ordinary': 'Ordinary user',
  'pages.roles.systemIdentity.superAdmin': 'Super administrator',
  'pages.roles.systemIdentity.builtIn': 'Built-in',
  'pages.roles.systemIdentity.ordinarySummary':
    'Personal address book basic functionality only.',
  'pages.roles.systemIdentity.superAdminSummary':
    'Full effective authority for the unique system owner.',
  'pages.roles.systemIdentity.systemCapabilities':
    'Role definition, system settings, device-group structure and identity administration',
  'pages.roles.disableProtectionConfirm': 'Disable protection for this role?',
  'pages.roles.disableProtectionAffected':
    '{count} members will become manageable by delegated administrators.',
  'pages.roles.resource.servers': 'Servers',
  'pages.roles.permission.servers.view': 'View servers',
  'pages.roles.permission.servers.control': 'Control server services',
  'pages.roles.permission.servers.config': 'Configure servers',
  'pages.roles.permission.servers.disconnect': 'Disconnect relay sessions',
  'pages.roles.permission.servers.ban': 'Manage server bans',
  'pages.roles.resource.users': 'Users',
  'pages.roles.resource.user_groups': 'User groups',
  'pages.roles.resource.devices': 'Devices',
  'pages.roles.resource.address_books': 'Address books',
  'pages.roles.resource.strategies': 'Strategies',
  'pages.roles.resource.audit': 'Audit',
  'pages.roles.resource.roles': 'Roles',
  'pages.roles.resource.system': 'System capabilities',
  'pages.roles.resource.other': 'Other',
  'pages.roles.unknownResource': 'Unknown resource',
  'pages.roles.unknownPermission': 'Unknown permission',
  'pages.roles.permission.users.view': 'View users',
  'pages.roles.permission.users.create': 'Create users',
  'pages.roles.permission.users.edit': 'Edit users',
  'pages.roles.permission.users.status': 'Change user status',
  'pages.roles.permission.users.delete': 'Delete users',
  'pages.roles.permission.users.security': 'Manage user security',
  'pages.roles.permission.users.force_logout': 'Force user logout',
  'pages.roles.permission.user_groups.view': 'View user groups',
  'pages.roles.permission.user_groups.create': 'Create user groups',
  'pages.roles.permission.user_groups.edit': 'Edit user groups',
  'pages.roles.permission.user_groups.delete': 'Delete user groups',
  'pages.roles.permission.user_groups.membership':
    'Manage user group membership',
  'pages.roles.permission.devices.view': 'View devices',
  'pages.roles.permission.devices.edit': 'Edit device details',
  'pages.roles.permission.devices.status': 'Change device status',
  'pages.roles.permission.devices.delete': 'Delete devices',
  'pages.roles.permission.devices.disconnect': 'Disconnect devices',
  'pages.roles.permission.address_books.view':
    'View shared address book settings',
  'pages.roles.permission.address_books.edit': 'Edit shared address books',
  'pages.roles.permission.address_books.share':
    'Create and manage shared address books',
  'pages.roles.permission.strategies.view': 'View strategies',
  'pages.roles.permission.strategies.create': 'Create strategies',
  'pages.roles.permission.strategies.edit': 'Edit strategies',
  'pages.roles.permission.strategies.delete': 'Delete strategies',
  'pages.roles.permission.strategies.assign': 'Assign strategies',
  'pages.roles.permission.audit.view': 'View audit logs',
  'pages.roles.permission.roles.view': 'View roles',
  'pages.roles.permission.roles.assign': 'Assign roles',
  'pages.roles.permission.roles.create': 'Create roles',
  'pages.roles.permission.roles.edit': 'Edit roles',
  'pages.roles.permission.roles.delete': 'Delete roles',
  'pages.roles.create': 'Create Role',
  'pages.roles.view': 'View Role',
  'pages.roles.edit': 'Edit Role',
  'pages.roles.deleteConfirm': 'Are you sure to delete this role?',
  'pages.roles.selectPermissions': 'Select Permissions',
  'pages.roles.createSuccess': 'Role created successfully',
  'pages.roles.createFailed': 'Failed to create role',
  'pages.roles.updateSuccess': 'Role updated successfully',
  'pages.roles.updateFailed': 'Failed to update role',
  'pages.roles.deleteSuccess': 'Role deleted successfully',
  'pages.roles.deleteFailed': 'Failed to delete role',
  'pages.roles.searchNamePlaceholder': 'Search by role name',
  'pages.roles.searchNotePlaceholder': 'Search by note',
  'pages.settings.save': 'Save Settings',
  'pages.settings.general': 'General Settings',
  'pages.settings.fetchFailed': 'Failed to load settings',
  'pages.settings.saveSuccess': 'Settings saved successfully',
  'pages.settings.saveFailed': 'Failed to save settings',
  'pages.settings.generalSection.watermark': 'Username Watermark',
  'pages.settings.generalSection.watermarkExtra':
    'Overlay the current username on each page for accountability.',
  'pages.settings.generalSection.language': 'Default Language',
  'pages.settings.generalSection.languageExtra':
    'Default UI language for new visitors. Signed-in users keep their own preference.',
  'pages.settings.generalSection.languagePlaceholder':
    'Select default language',
  'pages.settings.generalSection.site': 'Site',
  'pages.settings.generalSection.frontendUrl': 'Frontend URL',
  'pages.settings.generalSection.frontendUrlPlaceholder':
    'https://console.example.com',
  'pages.settings.generalSection.backendUrl': 'Backend URL',
  'pages.settings.generalSection.backendUrlExtra':
    'Leave blank to use the same origin as the frontend.',
  'pages.settings.generalSection.backendUrlPlaceholder':
    'https://api.example.com',
  'pages.settings.generalSection.urlInvalid': 'Please enter a valid URL',
  'pages.settings.generalSection.webauthn': 'WebAuthn / Passkeys',
  'pages.settings.generalSection.webauthnEnabled': 'Enable WebAuthn',
  'pages.settings.generalSection.webauthnEnabledExtra':
    'Allow users to register and sign in with passkeys.',
  'pages.settings.generalSection.webauthnUnsupported':
    'This browser does not support WebAuthn. Passkey login will be unavailable for users on unsupported clients.',
  'pages.settings.generalSection.rpName': 'Relying Party Name',
  'pages.settings.generalSection.rpNameExtra':
    'Human-friendly name shown in the passkey prompt.',
  'pages.settings.generalSection.rpNamePlaceholder': 'RustDesk Console',
  'pages.settings.generalSection.security': 'Security & Maintenance',
  'pages.settings.generalSection.jwtExpiryDays': 'JWT Token Expiry (Days)',
  'pages.settings.generalSection.jwtExpiryDaysExtra':
    'Number of days before signed-in user tokens expire. Must be at least 1.',
  'pages.settings.generalSection.jwtExpiryDaysRequired':
    'Please enter a positive integer',
  'pages.settings.generalSection.auditRetentionDays':
    'Audit Log Retention (Days)',
  'pages.settings.generalSection.auditRetentionDaysExtra':
    'Number of days to keep audit logs before automatic cleanup. Set to 0 to disable auto-cleanup.',
  'pages.settings.generalSection.auditRetentionDaysRequired':
    'Please enter a non-negative integer',
  'pages.strategies.list': 'Strategy List',
  'pages.strategies.name': 'Strategy Name',
  'pages.strategies.note': 'Note',
  'pages.strategies.create': 'Create Strategy',
  'pages.strategies.edit': 'Edit Strategy',
  'pages.strategies.view': 'View Strategy',
  'pages.strategies.deleteConfirm': 'Are you sure to delete this strategy?',
  'pages.strategies.createSuccess': 'Strategy created',
  'pages.strategies.createFailed': 'Failed to create strategy',
  'pages.strategies.updateSuccess': 'Strategy updated',
  'pages.strategies.updateFailed': 'Failed to update strategy',
  'pages.strategies.deleteSuccess': 'Strategy deleted',
  'pages.strategies.deleteFailed': 'Failed to delete strategy',
  'pages.strategies.enterName': 'Enter strategy name',
  'pages.strategies.configOptions': 'Configuration Options',
  'pages.strategies.defaultLabel': 'Default',
  'pages.strategies.defaultValue': 'Default: {value}',
  'pages.strategies.resetToDefault': 'Reset to default',
  'pages.strategies.modifiedSummary': '{count} config(s) modified',
  'pages.strategies.resetAll': 'Reset All',
  'pages.strategies.assign': 'Assign',
  'pages.strategies.assignManagement': 'Assign Management',
  'pages.strategies.loadAssignedFailed': 'Failed to load assigned targets',
  'pages.strategies.loadTargetsFailed': 'Failed to load targets',
  'pages.strategies.assignDevice': 'Device',
  'pages.strategies.assignUser': 'User',
  'pages.strategies.assignDeviceGroup': 'Device Group',
  'pages.strategies.assignedTargets': 'Assigned Targets',
  'pages.strategies.noAssigned': 'No assigned targets',
  'pages.strategies.addAssignment': 'Add Assignment',
  'pages.strategies.selectTarget': 'Select target',
  'pages.strategies.assignSuccess': 'Strategy assigned successfully',
  'pages.strategies.assignFailed': 'Failed to assign strategy',
  'pages.strategies.assignPartialFailed':
    'Assigned {success} target(s), {failed} failed: {errors}',
  'pages.strategies.unassignSuccess': 'Strategy unassigned successfully',
  'pages.strategies.unassignFailed': 'Failed to unassign strategy',
  'pages.strategies.unassignConfirm': 'Unassign this target?',
  'pages.strategies.fetchDetailFailed': 'Failed to fetch strategy details',
  'pages.strategies.updatedAt': 'Updated At',
  'pages.strategies.category.connection': 'Connection & Access',
  'pages.strategies.category.security': 'Security & Auth',
  'pages.strategies.category.display': 'Display & UI',
  'pages.strategies.category.av': 'Audio/Video & Codec',
  'pages.strategies.category.file': 'File & Clipboard',
  'pages.strategies.category.advanced': 'Advanced',
  'pages.strategies.category.floating': 'Floating Window',
  'pages.strategies.category.privacy': 'Privacy & Recording',
  'pages.strategies.values.yes': 'Yes',
  'pages.strategies.values.no': 'No',
  'pages.strategies.option.access-mode.label': 'Access Mode',
  'pages.strategies.option.enable-keyboard.label': 'Enable Keyboard and Mouse',
  'pages.strategies.option.enable-clipboard.label': 'Enable Clipboard',
  'pages.strategies.option.enable-file-transfer.label': 'Enable File Transfer',
  'pages.strategies.option.enable-camera.label': 'Enable Camera',
  'pages.strategies.option.enable-terminal.label': 'Enable Terminal',
  'pages.strategies.option.enable-remote-printer.label':
    'Enable Remote Printer',
  'pages.strategies.option.enable-tunnel.label': 'Enable Tunnel',
  'pages.strategies.option.enable-remote-restart.label':
    'Enable Remote Restart',
  'pages.strategies.option.enable-block-input.label': 'Block Input',
  'pages.strategies.option.allow-auto-disconnect.label':
    'Allow Auto Disconnect',
  'pages.strategies.option.auto-disconnect-timeout.label':
    'Auto Disconnect Timeout',
  'pages.strategies.option.allow-only-conn-window-open.label':
    'Only Allow Connection Window Open',
  'pages.strategies.option.view-only.label': 'View Only',
  'pages.strategies.option.terminal-persistent.label': 'Persistent Terminal',
  'pages.strategies.option.allow-ask-for-note.label': 'Ask for Connection Note',
  'pages.strategies.option.allow-remote-config-modification.label':
    'Allow Remote Configuration Modification',
  'pages.strategies.option.whitelist.label': 'IP Whitelist',
  'pages.strategies.option.approve-mode.label': 'Approval Mode',
  'pages.strategies.option.verification-method.label': 'Verification Method',
  'pages.strategies.option.temporary-password-length.label':
    'Temporary Password Length',
  'pages.strategies.option.lock-after-session-end.label':
    'Lock After Session End',
  'pages.strategies.option.allow-remote-cm-modification.label':
    'Allow Remote Client Modification',
  'pages.strategies.option.enable-trusted-devices.label':
    'Enable Trusted Devices',
  'pages.strategies.option.allow-numeric-one-time-password.label':
    'Allow Numeric One-Time Password',
  'pages.strategies.option.allow-insecure-tls-fallback.label':
    'Allow Insecure TLS Fallback',
  'pages.strategies.option.theme.label': 'Theme',
  'pages.strategies.option.lang.label': 'Language',
  'pages.strategies.option.enable-confirm-closing-tabs.label':
    'Confirm Closing Tabs',
  'pages.strategies.option.allow-remove-wallpaper.label':
    'Allow Remove Wallpaper',
  'pages.strategies.option.enable-open-new-connections-in-tabs.label':
    'Open New Connections in Tabs',
  'pages.strategies.option.peer-card-ui-type.label': 'Peer Card UI Type',
  'pages.strategies.option.peer-sorting.label': 'Peer Sorting',
  'pages.strategies.option.show-monitors-toolbar.label':
    'Show Monitors Toolbar',
  'pages.strategies.option.collapse-toolbar.label': 'Collapse Toolbar',
  'pages.strategies.option.show-remote-cursor.label': 'Show Remote Cursor',
  'pages.strategies.option.follow-remote-cursor.label': 'Follow Remote Cursor',
  'pages.strategies.option.follow-remote-window.label': 'Follow Remote Window',
  'pages.strategies.option.zoom-cursor.label': 'Zoom Cursor',
  'pages.strategies.option.show-quality-monitor.label': 'Show Quality Monitor',
  'pages.strategies.option.reverse-mouse-wheel.label': 'Reverse Mouse Wheel',
  'pages.strategies.option.swap-left-right-mouse.label':
    'Swap Left and Right Mouse Buttons',
  'pages.strategies.option.displays-as-individual-windows.label':
    'Displays as Individual Windows',
  'pages.strategies.option.use-all-my-displays-for-the-remote-session.label':
    'Use All Displays for Remote Session',
  'pages.strategies.option.view-style.label': 'View Style',
  'pages.strategies.option.scroll-style.label': 'Scroll Style',
  'pages.strategies.option.edge-scroll-edge-thickness.label':
    'Edge Scroll Thickness',
  'pages.strategies.option.trackpad-speed.label': 'Trackpad Speed',
  'pages.strategies.option.disable-group-panel.label': 'Disable Group Panel',
  'pages.strategies.option.keep-screen-on.label': 'Keep Screen On',
  'pages.strategies.option.disable-discovery-panel.label':
    'Disable Discovery Panel',
  'pages.strategies.option.touch-mode.label': 'Touch Mode',
  'pages.strategies.option.show-virtual-mouse.label': 'Show Virtual Mouse',
  'pages.strategies.option.show-virtual-joystick.label':
    'Show Virtual Joystick',
  'pages.strategies.option.enable-audio.label': 'Enable Audio',
  'pages.strategies.option.allow-always-software-render.label':
    'Always Use Software Rendering',
  'pages.strategies.option.enable-hwcodec.label': 'Enable Hardware Codec',
  'pages.strategies.option.use-texture-render.label': 'Use Texture Rendering',
  'pages.strategies.option.disable-audio.label': 'Disable Audio',
  'pages.strategies.option.i444.label': 'I444 Color Format',
  'pages.strategies.option.image-quality.label': 'Image Quality',
  'pages.strategies.option.custom-image-quality.label': 'Custom Image Quality',
  'pages.strategies.option.custom-fps.label': 'Custom FPS',
  'pages.strategies.option.enable-directx-capture.label':
    'Enable DirectX Capture',
  'pages.strategies.option.enable-android-software-encoding-half-scale.label':
    'Half-Scale Android Software Encoding',
  'pages.strategies.option.allow-d3d-render.label': 'Allow D3D Rendering',
  'pages.strategies.option.enable-file-copy-paste.label':
    'Enable File Copy and Paste',
  'pages.strategies.option.disable-clipboard.label': 'Disable Clipboard',
  'pages.strategies.option.sync-init-clipboard.label': 'Sync Initial Clipboard',
  'pages.strategies.option.enable-lan-discovery.label': 'Enable LAN Discovery',
  'pages.strategies.option.direct-server.label': 'Direct Server',
  'pages.strategies.option.allow-auto-update.label': 'Allow Automatic Updates',
  'pages.strategies.option.enable-abr.label': 'Enable Adaptive Bitrate',
  'pages.strategies.option.allow-linux-headless.label':
    'Allow Linux Headless Mode',
  'pages.strategies.option.sync-ab-with-recent-sessions.label':
    'Sync Address Book with Recent Sessions',
  'pages.strategies.option.sync-ab-tags.label': 'Sync Address Book Tags',
  'pages.strategies.option.filter-ab-by-intersection.label':
    'Filter Address Book by Intersection',
  'pages.strategies.option.enable-udp-punch.label': 'Enable UDP Hole Punching',
  'pages.strategies.option.enable-ipv6-punch.label':
    'Enable IPv6 Hole Punching',
  'pages.strategies.option.pre-elevate-service.label': 'Pre-Elevate Service',
  'pages.strategies.option.keep-awake-during-incoming-sessions.label':
    'Keep Awake During Incoming Sessions',
  'pages.strategies.option.keep-awake-during-outgoing-sessions.label':
    'Keep Awake During Outgoing Sessions',
  'pages.strategies.option.disable-udp.label': 'Disable UDP',
  'pages.strategies.option.allow-websocket.label': 'Allow WebSocket',
  'pages.strategies.option.disable-floating-window.label':
    'Disable Floating Window',
  'pages.strategies.option.floating-window-size.label': 'Floating Window Size',
  'pages.strategies.option.floating-window-untouchable.label':
    'Floating Window Untouchable',
  'pages.strategies.option.floating-window-transparency.label':
    'Floating Window Transparency',
  'pages.strategies.option.enable-record-session.label':
    'Enable Session Recording',
  'pages.strategies.option.allow-auto-record-incoming.label':
    'Allow Automatic Recording for Incoming Sessions',
  'pages.strategies.option.allow-auto-record-outgoing.label':
    'Allow Automatic Recording for Outgoing Sessions',
  'pages.strategies.option.privacy-mode.label': 'Privacy Mode',
  'pages.strategies.option.auto-disconnect-timeout.description':
    'Timeout in minutes',
  'pages.strategies.option.lang.description': 'Language code',
  'pages.strategies.option.enable-ipv6-punch.description':
    'Self-hosted: N, others: Y',
  'pages.strategies.option.use-texture-render.description':
    'Platform dependent',
  'pages.strategies.option.whitelist.description': 'Comma-separated IP list',
  'pages.strategies.option.image-quality.value.best': 'Best',
  'pages.strategies.option.image-quality.value.balanced': 'Balanced',
  'pages.strategies.option.image-quality.value.low': 'Low',
  'pages.strategies.option.image-quality.value.custom': 'Custom',
  'pages.strategies.option.access-mode.value.custom': 'Custom',
  'pages.strategies.option.access-mode.value.full': 'Full Access',
  'pages.strategies.option.access-mode.value.view': 'View Only',
  'pages.strategies.option.theme.value.dark': 'Dark',
  'pages.strategies.option.theme.value.light': 'Light',
  'pages.strategies.option.theme.value.system': 'System',
  'pages.strategies.option.peer-card-ui-type.value.0': 'Card Style 0',
  'pages.strategies.option.peer-card-ui-type.value.1': 'Card Style 1',
  'pages.strategies.option.peer-card-ui-type.value.2': 'Card Style 2',
  'pages.strategies.option.peer-sorting.value.remote-id': 'Remote ID',
  'pages.strategies.option.peer-sorting.value.remote-host': 'Remote Host',
  'pages.strategies.option.peer-sorting.value.username': 'Username',
  'pages.strategies.option.view-style.value.original': 'Original',
  'pages.strategies.option.view-style.value.adaptive': 'Adaptive',
  'pages.strategies.option.scroll-style.value.scrollauto': 'Auto',
  'pages.strategies.option.scroll-style.value.scrollbar': 'Scrollbar',
  'pages.strategies.option.scroll-style.value.scrolledge': 'Edge Scrolling',
  'pages.strategies.option.keep-screen-on.value.never': 'Never',
  'pages.strategies.option.keep-screen-on.value.during-controlled':
    'During Controlled Session',
  'pages.strategies.option.keep-screen-on.value.service-on': 'Service On',
  'pages.strategies.option.approve-mode.value.password': 'Password',
  'pages.strategies.option.approve-mode.value.click': 'Click',
  'pages.strategies.option.approve-mode.value.password-click':
    'Password and Click',
  'pages.strategies.option.verification-method.value.use-temporary-password':
    'Temporary Password',
  'pages.strategies.option.verification-method.value.use-permanent-password':
    'Permanent Password',
  'pages.strategies.option.verification-method.value.use-both-passwords':
    'Both Passwords',
  'pages.strategies.option.temporary-password-length.value.6': '6 digits',
  'pages.strategies.option.temporary-password-length.value.8': '8 digits',
  'pages.strategies.option.temporary-password-length.value.10': '10 digits',
  'pages.strategies.searchNamePlaceholder': 'Search by strategy name',
  'pages.users.inviteSuccess': 'Invitation sent',
  'pages.users.inviteFailed': 'Failed to send invitation',
  'pages.users.active': 'Active',
  'pages.users.disabled': 'Disabled',
  'pages.users.unverified': 'Unverified',
  'pages.users.roles': 'Roles',
  'pages.users.rolesTitle': 'Roles for {name}',
  'pages.users.rolesLoadFailed': 'Failed to load user roles',
  'pages.users.rolesSaveFailed': 'Failed to save user roles',
  'pages.users.rolesSaved': 'User roles saved',
  'pages.users.addRole': 'Add role',
  'pages.users.superAdmin': 'Super administrator',
  'pages.users.roleAssignmentTitle': 'Role {number}',
  'pages.users.selectRole': 'Select role',
  'pages.users.removeRole': 'Remove role',
  'pages.users.roleRequired': 'Select a role for every assignment',
  'pages.users.duplicateRole': 'A role can only be assigned once',
  'pages.users.scopeMode': 'Role scope mode',
  'pages.users.globalScope': 'Global',
  'pages.users.deviceGroupScope': 'Selected device groups',
  'pages.users.selectDeviceGroups': 'Select one or more device groups',
  'pages.users.unsupportedDeviceGroupScope':
    'Device-group scope is only available for roles containing device actions and strategy assignment',
  'pages.users.deviceGroupScopeRequired':
    'Select at least one device group for a device-group assignment',
  'pages.users.rolesScopeInfo':
    'Global grants override narrower device-group grants.',
  'pages.users.protectedAccount': 'Protected account',
  'pages.users.protectedAccountInfo':
    'Protected accounts can only be managed by the super administrator.',
  'pages.users.systemOwnerStatusBlocked':
    'The system owner cannot be enabled or disabled.',
  'pages.users.systemOwnerMutationBlocked':
    'The system owner cannot be disabled or deleted.',
  'pages.users.systemCapabilities': 'System capabilities',
  'pages.users.systemCapability.roles.create': 'Create role definitions',
  'pages.users.systemCapability.roles.edit': 'Edit role definitions',
  'pages.users.systemCapability.roles.delete': 'Delete role definitions',
  'pages.users.systemCapability.settings.manage': 'Manage system settings',
  'pages.users.systemCapability.device_groups.manage':
    'Manage device-group structure',
  'pages.users.systemCapability.identity_sources.manage':
    'Manage identity sources',
  'pages.users.roleEligibility.assign_not_allowed':
    'You cannot assign this role',
  'pages.users.roleEligibility.remove_not_allowed':
    'You cannot remove this role',
  'pages.users.roleEligibility.protected_role':
    'Protected roles can only be assigned or removed by the super administrator',
  'pages.users.roleEligibility.protected_target':
    'The target account is protected',
  'pages.users.roleEligibility.super_admin_target':
    'Ordinary roles cannot be assigned to the super administrator',
  'pages.users.roleEligibility.self_target': 'You cannot change your own roles',
  'pages.users.roleEligibility.missing_caller_scope':
    'Your permission scope is insufficient',
  'pages.users.roleEligibility.scope_exceeds_caller':
    'The role scope exceeds your permissions',
  'pages.users.roleEligibility.missing_permission':
    'You lack a permission required by this role',
  'pages.users.roleEligibility.role_grants_roles_assign':
    'Roles that grant role assignment can only be managed by the super administrator',
  'pages.users.effectiveScope': 'Effective scope',
  'pages.users.strategy': 'Strategy',
  'pages.users.invite': 'Invite User',
  'pages.users.password': 'Password',
  'pages.users.isAdmin': 'Admin',
  'pages.users.normalUser': 'Normal',
  'pages.users.edit': 'Edit User',
  'pages.users.updateSuccess': 'User updated',
  'pages.users.updateFailed': 'Failed to update user',
  'pages.users.security': 'Security',
  'pages.users.securitySettings': 'Security Settings',
  'pages.users.securityUpdateSuccess': 'Security settings updated',
  'pages.users.securityUpdateFailed': 'Failed to update security settings',
  'pages.users.tfaEnforce': 'Enforce Two-Factor Authentication',
  'pages.users.emailVerification': 'Require Email Verification',
  'pages.users.resetPassword': 'Reset Password',
  'pages.users.resetPasswordTooltip': 'Leave blank to keep current password',
  'pages.users.confirmPassword': 'Confirm Password',
  'pages.users.passwordMismatch': 'Passwords do not match',
  'pages.users.passwordTooShort': 'Password must be at least 6 characters',
  'pages.users.forceLogout': 'Logout',
  'pages.users.forceLogoutSuccess': 'Force logout successful',
  'pages.users.forceLogoutFailed': 'Failed to force logout',
  'pages.users.batchEnable': 'Batch Enable',
  'pages.users.batchDisable': 'Batch Disable',
  'pages.users.batchForceLogout': 'Batch Force Logout',
  'pages.users.batchEnableConfirm': 'Are you sure to enable selected users?',
  'pages.users.batchDisableConfirm': 'Are you sure to disable selected users?',
  'pages.users.batchForceLogoutConfirm':
    'Are you sure to force logout selected users?',
  'pages.users.batchEnableSuccess': 'Successfully enabled {count} user(s)',
  'pages.users.batchEnableFailed': 'Failed to enable users',
  'pages.users.batchEnablePartialFailed':
    'Successfully enabled {success} user(s), {failed} failed',
  'pages.users.batchDisableSuccess': 'Successfully disabled {count} user(s)',
  'pages.users.batchDisableFailed': 'Failed to disable users',
  'pages.users.batchDisablePartialFailed':
    'Successfully disabled {success} user(s), {failed} failed',
  'pages.users.batchForceLogoutSuccess': 'Batch force logout successful',
  'pages.users.batchForceLogoutFailed': 'Failed to force logout users',
  'pages.dashboard.totalUsers': 'Total Users',
  'pages.dashboard.adminUsers': 'Admin',
  'pages.dashboard.normalUsers': 'Normal',
  'pages.dashboard.totalDevices': 'Total Devices',
  'pages.dashboard.onlineDevices': 'Online',
  'pages.dashboard.offlineDevices': 'Offline',
  'pages.dashboard.todayConnections': 'Today Connections',
  'pages.dashboard.successCount': 'Success',
  'pages.dashboard.failureCount': 'Failed',
  'pages.dashboard.todayTransfers': 'Today Transfers',
  'pages.dashboard.uploadCount': 'Upload',
  'pages.dashboard.downloadCount': 'Download',
  'pages.dashboard.systemStatus': 'System Status',
  'pages.dashboard.uptime': 'Uptime',
  'pages.dashboard.trendData': 'Trend Data',
  'pages.dashboard.alarmTrend': 'Alarms',
  'pages.dashboard.resourceCounts': 'Resource Counts',
  'pages.dashboard.addressBooks': 'Address Books',
  'pages.dashboard.groups': 'Groups',
  'pages.dashboard.roles': 'Roles',
  'pages.dashboard.strategies': 'Strategies',
  'pages.common.pleaseEnterName': 'Please enter name',
  'pages.common.pleaseEnterId': 'Please enter ID',
  'pages.common.pleaseEnterTagName': 'Please enter tag name',
  'pages.common.pleaseEnterUsername': 'Please enter username',
  'pages.common.pleaseEnterEmail': 'Please enter email',
  'pages.common.pleaseEnterValidEmail': 'Please enter valid email',
  'pages.common.pleaseEnterPassword': 'Please enter password',
  'pages.common.pleaseEnterRoleName': 'Please enter role name',
  'pages.common.id': 'ID',
  'pages.dashboard.day': 'd',
  'pages.dashboard.hour': 'h',
  'pages.dashboard.min': 'min',
  'pages.dashboard.cpu': 'CPU',
  'pages.dashboard.memory': 'Memory',
  'pages.dashboard.disk': 'Disk',
  'pages.dashboard.connectionTrend': 'Connections',
  'pages.dashboard.newUsersTrend': 'New Users',

  'pages.dashboard.7days': '7 Days',
  'pages.dashboard.30days': '30 Days',
  'pages.dashboard.90days': '90 Days',
  'pages.dashboard.noData': 'No data',
  'pages.smtp.title': 'SMTP Configuration',
  'pages.smtp.description':
    'Configure SMTP mail server for sending system notification emails',
  'pages.smtp.host': 'Server Address',
  'pages.smtp.hostPlaceholder': 'Please enter SMTP server address',
  'pages.smtp.port': 'Port',
  'pages.smtp.portPlaceholder': 'Please enter port number',
  'pages.smtp.secure': 'Use SSL/TLS',
  'pages.smtp.secureHelp':
    'Enable secure connection (usually port 465 uses SSL, port 587 uses TLS)',
  'pages.smtp.user': 'Username',
  'pages.smtp.userPlaceholder': 'Please enter SMTP authentication username',
  'pages.smtp.password': 'Password',
  'pages.smtp.passwordPlaceholder': 'Please enter SMTP authentication password',
  'pages.smtp.from': 'Sender Email',
  'pages.smtp.fromPlaceholder': 'Please enter sender email address',
  'pages.smtp.enabled': 'Enable Configuration',
  'pages.smtp.enabledHelp':
    'When enabled, this configuration will be used to send system emails',
  'pages.smtp.testConnection': 'Test Connection',
  'pages.smtp.testSuccess': 'SMTP connection test successful',
  'pages.smtp.testFailed': 'SMTP connection test failed',
  'pages.smtp.saveSuccess': 'SMTP configuration saved successfully',
  'pages.smtp.saveFailed': 'Failed to save SMTP configuration',
  'pages.smtp.createdAt': 'Created At',
  'pages.smtp.updatedAt': 'Updated At',
  'pages.addressBook.color': 'Color',
  'pages.addressBook.deviceInfo': 'username@device_name',
  'pages.addressBook.manageTags': 'Manage Tags',
  'pages.addressBook.newTagName': 'New Tag Name',
  'pages.addressBook.peerUpdateFailed': 'Failed to update peer',
  'pages.addressBook.peerUpdated': 'Peer updated',
  'pages.addressBook.renameTag': 'Rename Tag',
  'pages.addressBook.selectTags': 'Select tags',
  'pages.addressBook.tagColorUpdateFailed': 'Failed to update tag color',
  'pages.addressBook.tagRenameFailed': 'Failed to rename tag',
  'pages.addressBook.tagRenamed': 'Tag renamed',
  'pages.addressBook.untagged': 'Untagged',
  'pages.addressBook.searchIdPlaceholder': 'Search by ID',
  'pages.addressBook.searchNamePlaceholder': 'Search by name',
  'pages.addressBook.searchNotePlaceholder': 'Search by note',
  'pages.common.cancel': 'No',
  'pages.common.confirm': 'Yes',
  'pages.common.enterDescription': 'Enter description',
  'pages.common.rename': 'Rename',
  'pages.common.save': 'Save',
  'pages.common.close': 'Close',
  'pages.common.back': 'Back',
  'pages.userGroups.enterName': 'Enter group name',
  'pages.userGroups.searchNamePlaceholder': 'Search by name',
  'pages.users.admin': 'Admin',
  'pages.users.me': 'Me',
  'pages.users.searchNamePlaceholder': 'Search by username',
  'pages.users.searchEmailPlaceholder': 'Search by email',
  'pages.users.searchStrategyPlaceholder': 'Search by strategy',
  'pages.users.searchUserGroupPlaceholder': 'Search by user group',
  'pages.oidcProviders.list': 'OIDC Providers',
  'pages.oidcProviders.sort': 'Sort',
  'pages.oidcProviders.name': 'Provider Name',
  'pages.oidcProviders.type': 'Type',
  'pages.oidcProviders.issuer': 'Issuer URL',
  'pages.oidcProviders.clientId': 'Client ID',
  'pages.oidcProviders.clientSecret': 'Client Secret',
  'pages.oidcProviders.scope': 'Scope',
  'pages.oidcProviders.authorizationEndpoint': 'Authorization Endpoint',
  'pages.oidcProviders.tokenEndpoint': 'Token Endpoint',
  'pages.oidcProviders.userinfoEndpoint': 'Userinfo Endpoint',
  'pages.oidcProviders.jwksUri': 'JWKS URI',
  'pages.oidcProviders.enabled': 'Enabled',
  'pages.oidcProviders.endpointConfig': 'Endpoint Configuration',
  'pages.oidcProviders.create': 'Create Provider',
  'pages.oidcProviders.edit': 'Edit Provider',
  'pages.oidcProviders.test': 'Test',
  'pages.oidcProviders.testResult': 'Test Connection Result',
  'pages.oidcProviders.discoveredEndpoints': 'Discovered Endpoints',
  'pages.oidcProviders.enterName': 'Enter provider name',
  'pages.oidcProviders.enterIssuer': 'Enter issuer URL',
  'pages.oidcProviders.enterClientId': 'Enter client ID',
  'pages.oidcProviders.enterClientSecret': 'Enter client secret',
  'pages.oidcProviders.enterEndpoint': 'Auto-discovered if empty',
  'pages.oidcProviders.createSuccess': 'OIDC provider created',
  'pages.oidcProviders.createFailed': 'Failed to create OIDC provider',
  'pages.oidcProviders.updateSuccess': 'OIDC provider updated',
  'pages.oidcProviders.updateFailed': 'Failed to update OIDC provider',
  'pages.oidcProviders.deleteSuccess': 'OIDC provider deleted',
  'pages.oidcProviders.deleteFailed': 'Failed to delete OIDC provider',
  'pages.oidcProviders.deleteConfirm': 'Are you sure to delete this provider?',
  'pages.oidcProviders.enableSuccess': 'OIDC provider enabled',
  'pages.oidcProviders.enableFailed': 'Failed to enable OIDC provider',
  'pages.oidcProviders.disableSuccess': 'OIDC provider disabled',
  'pages.oidcProviders.disableFailed': 'Failed to disable OIDC provider',
  'pages.oidcProviders.enableConfirm': 'Are you sure to enable this provider?',
  'pages.oidcProviders.disableConfirm':
    'Are you sure to disable this provider?',
  'pages.oidcProviders.testFailed': 'Failed to test OIDC connection',
  'pages.oidcProviders.fetchDetailFailed': 'Failed to fetch provider details',
  'pages.oidcProviders.sortFailed': 'Failed to update provider order',
  'pages.oidcProviders.preset': 'Provider Template',
  'pages.oidcProviders.presetPlaceholder':
    'Select a built-in provider or custom',
  'pages.oidcProviders.custom': 'Custom',
  'pages.oidcProviders.icon': 'Icon (SVG)',
  'pages.oidcProviders.uploadSvg': 'Upload SVG',
  'pages.oidcProviders.clearIcon': 'Clear',
  'pages.oidcProviders.svgTooLarge': 'SVG file too large (max 100KB)',
  'pages.oidcProviders.invalidSvg': 'Invalid SVG content',
  'pages.user.center.tab.basic': 'Basic Information',
  'pages.user.center.tab.security': 'Security',
  'pages.user.center.basicInfo.displayName': 'Display Name',
  'pages.user.center.basicInfo.displayNamePlaceholder': 'Enter display name',
  'pages.user.center.basicInfo.name': 'Username',
  'pages.user.center.basicInfo.email': 'Email',
  'pages.user.center.basicInfo.note': 'Note',
  'pages.user.center.basicInfo.updateSuccess': 'Profile updated successfully',
  'pages.user.center.basicInfo.updateFailed': 'Failed to update profile',
  'pages.user.center.avatar.hint':
    'Supports JPG, PNG, WebP, max 2MB, will be resized to 256x256',
  'pages.user.center.avatar.upload': 'Upload Avatar',
  'pages.user.center.avatar.delete': 'Delete Avatar',
  'pages.user.center.avatar.deleteConfirm':
    'Are you sure to delete your avatar?',
  'pages.user.center.avatar.uploadSuccess': 'Avatar uploaded successfully',
  'pages.user.center.avatar.uploadFailed': 'Failed to upload avatar',
  'pages.user.center.avatar.deleteSuccess': 'Avatar deleted successfully',
  'pages.user.center.avatar.deleteFailed': 'Failed to delete avatar',
  'pages.user.center.avatar.fileTooLarge': 'File size cannot exceed 2MB',
  'pages.user.center.avatar.invalidFormat':
    'Only JPG, PNG, WebP formats are supported',
  'pages.user.center.security.title': 'Security Settings',
  'pages.user.center.security.2faStatus': '2FA Status',
  'pages.user.center.security.enabled': 'Enabled',
  'pages.user.center.security.disabled': 'Disabled',
  'pages.user.center.security.enable2FA': 'Enable 2FA',
  'pages.user.center.security.disable2FA': 'Disable 2FA',
  'pages.user.center.security.setup2FA': 'Setup Two-Factor Authentication',
  'pages.user.center.security.setupFailed': 'Failed to setup 2FA',
  'pages.user.center.security.scanQRCode':
    'Scan the QR code with your authenticator app, then enter the verification code below.',
  'pages.user.center.security.secretKey': 'Secret Key',
  'pages.user.center.security.verificationCode': 'Verification Code',
  'pages.user.center.security.enterCode': 'Please enter verification code',
  'pages.user.center.security.verifyAndEnable': 'Verify & Enable',
  'pages.user.center.security.enableSuccess': '2FA enabled successfully',
  'pages.user.center.security.enableFailed': 'Failed to enable 2FA',
  'pages.user.center.security.currentCode': 'Current Verification Code',
  'pages.user.center.security.confirmDisable': 'Confirm Disable',
  'pages.user.center.security.disableSuccess': '2FA disabled successfully',
  'pages.user.center.security.disableFailed': 'Failed to disable 2FA',
  'pages.user.center.security.password': 'Login Password',
  'pages.user.center.security.passwordSet': 'Set',
  'pages.user.center.security.passwordNotSet': 'Not Set',
  'pages.user.center.security.changePassword': 'Change Password',
  'pages.user.center.security.currentPassword': 'Current Password',
  'pages.user.center.security.enterCurrentPassword':
    'Please enter current password',
  'pages.user.center.security.newPassword': 'New Password',
  'pages.user.center.security.enterNewPassword':
    'Please enter new password (min 6 characters)',
  'pages.user.center.security.confirmNewPassword': 'Confirm New Password',
  'pages.user.center.security.confirmNewPasswordPlaceholder':
    'Please re-enter new password',
  'pages.user.center.security.passwordMinLength':
    'Password must be at least 6 characters',
  'pages.user.center.security.passwordMismatch':
    'The two passwords do not match',
  'pages.user.center.security.changePasswordSuccess':
    'Password changed successfully',
  'pages.user.center.security.changePasswordFailed':
    'Failed to change password',
  'pages.user.center.security.thirdPartyUser':
    'Third-party login users cannot change password',
  'pages.user.center.security.noPasswordUser':
    'No password set for this account',
  'pages.user.center.security.passkey.title': 'Passkey Management',
  'pages.user.center.security.passkey.register': 'Register Passkey',
  'pages.user.center.security.passkey.registerSuccess':
    'Passkey registered successfully',
  'pages.user.center.security.passkey.registerFailed':
    'Failed to register Passkey',
  'pages.user.center.security.passkey.deleteSuccess':
    'Passkey deleted successfully',
  'pages.user.center.security.passkey.deleteFailed': 'Failed to delete Passkey',
  'pages.user.center.security.passkey.deleteConfirm':
    'Are you sure to delete this Passkey?',
  'pages.user.center.security.passkey.name': 'Name',
  'pages.user.center.security.passkey.namePlaceholder': 'e.g. MacBook Touch ID',
  'pages.user.center.security.passkey.namePasskey': 'Name your Passkey',
  'pages.user.center.security.passkey.deviceType': 'Device Type',
  'pages.user.center.security.passkey.multiDevice': 'Multi-device',
  'pages.user.center.security.passkey.singleDevice': 'Single-device',
  'pages.user.center.security.passkey.createdAt': 'Created At',
  'pages.user.center.security.passkey.noCredentials': 'No Passkeys registered',
  'pages.user.center.security.passkey.tfaStatus': 'Passkey TFA',
  'pages.user.center.security.passkey.tfaEnabled': 'Passkey TFA enabled',
  'pages.user.center.security.passkey.tfaDisabled': 'Passkey TFA disabled',
  'pages.user.center.security.passkey.tfaToggleFailed':
    'Failed to toggle Passkey TFA',
  'pages.user.center.security.sessions.title': 'Login Sessions',
  'pages.user.center.security.sessions.device': 'Device',
  'pages.user.center.security.sessions.type': 'Type',
  'pages.user.center.security.sessions.browser': 'Browser',
  'pages.user.center.security.sessions.client': 'Client',
  'pages.user.center.security.sessions.os': 'OS',
  'pages.user.center.security.sessions.createdAt': 'Created At',
  'pages.user.center.security.sessions.expiresAt': 'Expires At',
  'pages.user.center.security.sessions.current': 'Current',
  'pages.user.center.security.sessions.revoke': 'Revoke',
  'pages.user.center.security.sessions.revokeConfirm':
    'Are you sure to revoke this session?',
  'pages.user.center.security.sessions.revokeSuccess':
    'Session revoked successfully',
  'pages.user.center.security.sessions.revokeFailed':
    'Failed to revoke session',
  'pages.user.center.security.sessions.cannotRevokeCurrent':
    'Cannot revoke current session',
  'pages.user.center.security.sessions.noSessions': 'No active sessions',
  'pages.ldap.title': 'LDAP Configuration',
  'pages.ldap.description':
    'Configure LDAP/Active Directory authentication. Users will be automatically authenticated via LDAP when enabled.',
  'pages.ldap.urls': 'Server URLs',
  'pages.ldap.urlsRequired': 'Please enter at least one LDAP server URL',
  'pages.ldap.urlPlaceholder': 'e.g. ldaps://ad.example.com:636',
  'pages.ldap.addUrl': 'Add Server URL',
  'pages.ldap.bindDN': 'Bind DN',
  'pages.ldap.bindDNRequired': 'Please enter the service account Bind DN',
  'pages.ldap.bindDNPlaceholder':
    'e.g. CN=svc-ldap,OU=ServiceAccounts,DC=example,DC=com',
  'pages.ldap.bindCredentials': 'Bind Password',
  'pages.ldap.bindCredentialsRequired':
    'Please enter the service account password',
  'pages.ldap.bindCredentialsPlaceholder':
    'Please enter the service account password',
  'pages.ldap.searchBase': 'Search Base DN',
  'pages.ldap.searchBaseRequired': 'Please enter the search base DN',
  'pages.ldap.searchBasePlaceholder': 'e.g. DC=example,DC=com',
  'pages.ldap.searchFilter': 'Search Filter',
  'pages.ldap.searchFilterRequired': 'Please enter the search filter',
  'pages.ldap.searchFilterHelp':
    'Use {{username}} as the username placeholder. AD: (sAMAccountName={{username}}), OpenLDAP: (uid={{username}})',
  'pages.ldap.searchFilterPlaceholder': 'e.g. (sAMAccountName={{username}})',
  'pages.ldap.searchAttributes': 'Search Attributes',
  'pages.ldap.searchAttributePlaceholder':
    'e.g. dn, sAMAccountName, mail, displayName',
  'pages.ldap.addAttribute': 'Add Attribute',
  'pages.ldap.groupSearchBase': 'Group Search Base DN',
  'pages.ldap.groupSearchBasePlaceholder': 'e.g. OU=Groups,DC=example,DC=com',
  'pages.ldap.groupSearchFilter': 'Group Search Filter',
  'pages.ldap.groupSearchFilterHelp':
    'Use {{dn}} as the user DN placeholder. e.g. (member={{dn}})',
  'pages.ldap.groupSearchFilterPlaceholder': 'e.g. (member={{dn}})',
  'pages.ldap.adminGroups': 'Admin Groups',
  'pages.ldap.adminGroupsHelp':
    'Users in these LDAP groups will be mapped as administrators (case-insensitive match)',
  'pages.ldap.adminGroupPlaceholder':
    'e.g. CN=Admins,OU=Groups,DC=example,DC=com',
  'pages.ldap.addAdminGroup': 'Add Admin Group',
  'pages.ldap.tlsOptions': 'TLS Options',
  'pages.ldap.tlsCa': 'CA Certificate (PEM)',
  'pages.ldap.tlsCaPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsCert': 'Client Certificate (PEM)',
  'pages.ldap.tlsCertPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsKey': 'Client Private Key (PEM)',
  'pages.ldap.tlsKeyPlaceholder': '-----BEGIN PRIVATE KEY-----\n...',
  'pages.ldap.tlsServername': 'SNI Server Name',
  'pages.ldap.tlsServernamePlaceholder': 'Server Name Indication for TLS',
  'pages.ldap.enabled': 'Enable LDAP Authentication',
  'pages.ldap.enabledHelp':
    'When enabled, users will be authenticated against the LDAP server. Existing LDAP-linked users will always use LDAP authentication regardless of this setting.',
  'pages.ldap.testConnection': 'Test Connection',
  'pages.ldap.testSuccess': 'LDAP connection test successful',
  'pages.ldap.testFailed': 'LDAP connection test failed',
  'pages.ldap.saveSuccess': 'LDAP configuration saved successfully',
  'pages.ldap.saveFailed': 'Failed to save LDAP configuration',
  'pages.ldap.createdAt': 'Created At',
  'pages.ldap.updatedAt': 'Updated At',
  'pages.nexus.repoRequired': 'Repository Interaction Required',
  'pages.nexus.repoRequiredDesc':
    'You need to Star, Fork or Watch the databk/rustdesk-console repository on GitHub before generating custom clients. It may take up to 5 minutes for the cache to refresh.',
  'pages.nexus.goToRepo': 'Go to GitHub Repository',
  'pages.nexus.buildList': 'Build History',
  'pages.nexus.createBuild': 'Create New Client',
  'pages.nexus.createBuildTitle': 'Create Custom Client',
  'pages.nexus.customConfig': 'Custom Configuration',
  'pages.nexus.serverConfig': 'Server Configuration',
  'pages.nexus.password': 'Password',
  'pages.nexus.passwordPlaceholder': 'Enter password',
  'pages.nexus.salt': 'Salt',
  'pages.nexus.saltPlaceholder': 'Enter salt',
  'pages.nexus.connType': 'Connection Type',
  'pages.nexus.disableInstallation': 'Disable Installation',
  'pages.nexus.disableSettings': 'Disable Settings',
  'pages.nexus.disableAccount': 'Disable Account',
  'pages.nexus.disableAb': 'Disable AB',
  'pages.nexus.disableTcpListen': 'Disable TCP Listen',
  'pages.nexus.rendezvousServer': 'ID Server',
  'pages.nexus.relayServer': 'Relay Server',
  'pages.nexus.key': 'Key',
  'pages.nexus.apiServer': 'API Server',
  'pages.nexus.overrideSettings': 'Override Settings',
  'pages.nexus.defaultSettings': 'Default Settings',
  'pages.nexus.deleteBuildConfirm':
    'Are you sure you want to delete this build record?',
  'pages.nexus.deleteSuccess': 'Build record deleted',
  'pages.nexus.deleteFailed': 'Failed to delete build record',
  'pages.nexus.uuid': 'UUID',
  'pages.nexus.os': 'Operating System',
  'pages.nexus.arch': 'Architecture',
  'pages.nexus.appName': 'Application Name',
  'pages.nexus.appNamePlaceholder': 'e.g. my-rustdesk',
  'pages.nexus.appNameHint': 'Only English letters allowed',
  'pages.nexus.bindSuccess': 'Github account bound successfully',
  'pages.nexus.bindFailed': 'Failed to bind Github account',
  'pages.nexus.createLoginFailed': 'Failed to create login session',
  'pages.nexus.unbindConfirm': 'Unbind Github Account',
  'pages.nexus.unbindConfirmContent':
    'Are you sure you want to unbind your Github account? You will need to re-bind to generate custom clients.',
  'pages.nexus.unbindSuccess': 'Github account unbound',
  'pages.nexus.unbindFailed': 'Failed to unbind Github account',
  'pages.nexus.tokenExpired': 'Github Token Expired',
  'pages.nexus.tokenExpiredDesc':
    'Your Github token for {username} has expired. Please re-bind your account.',
  'pages.nexus.rebind': 'Re-bind Github Account',
  'pages.nexus.bindTitle': 'Bind Github Account',
  'pages.nexus.bindDesc':
    'You need to bind your GitHub account to generate custom clients. Click the button below to authorize via GitHub.',
  'pages.nexus.bindGithub': 'Authorize with GitHub',
  'pages.nexus.unbind': 'Unbind',
  'pages.nexus.repoInteractionRequired':
    'Please Star, Fork or Watch the databk/rustdesk-console repository on GitHub first. It may take up to 5 minutes for the cache to refresh.',
  'pages.nexus.buildAlreadyRunning': 'You already have a build in progress',
  'pages.nexus.generateFailed': 'Failed to submit build request',
  'pages.nexus.retryBuild': 'Retry',
  'pages.nexus.retryBuildFailed': 'Failed to retry build',
  'pages.nexus.downloadFailed': 'Failed to download custom client',
  'pages.nexus.buildAgain': 'Build Again',
  'pages.nexus.status': 'Status',
  'pages.nexus.statusPending': 'Build Pending',
  'pages.nexus.statusBuilding': 'Building',
  'pages.nexus.statusCompleted': 'Build Completed',
  'pages.nexus.statusFailed': 'Build Failed',
  'pages.nexus.statusCancelled': 'Build Cancelled',
  'pages.nexus.bindWhyLogin':
    'GitHub authentication helps us verify that you are a real user, preventing automated abuse of build resources. We only request your public data — no access to your repositories, personal data, or any other permissions is needed.',
  'pages.nexus.repoWhyInteract':
    "I'm a high school student developing this project in my spare time. Your Star, Fork, or Watch means a lot to me — it not only keeps me motivated, but also helps with my college applications. This is the only thing I ask for in return. Thank you so much for your support!",
};
